// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.attach-folio {
  margin: 0;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  background-color: var(--orwi-dialog-color);
  box-shadow: var(--orwi-shadow);
  border-radius: var(--orwi-radius);
  color: var(--ion-text-color);
  z-index: 101;
  height: 100%;
  width: 100%;
  opacity: 0;
  font-family: "Inter";
  padding-top: var(--ion-safe-area-top);
}

.attach-folio-inner {
  /* height: 100%;
  z-index: 101;
  background-color: #807b7bf1;
  left: 0px;
  width: 100%;

  backdrop-filter: blur(10px);
  border-radius: 30px 30px 0px 0px;
  padding-left: 20px;
  padding-right: 20px;
  position: absolute; */
  margin-bottom: 20px;
  padding: 20px;
}

.divider {
  background-color: white;
  width: 50%;
  border-radius: 20px;
  font-size: 7px;
  margin: auto;
  margin-bottom: 5px;
  height: 10px;
  margin-top: 10px;
}

.title {
  width: 100%;
  background-color: var(--ion-color-success);
  color: var(--ion-color-success-contrast);
  padding: 9px;
  font-weight: bold;
  min-height: 35px;
}

.orwi-actio-backdrop {
  background-color: rgba(171, 172, 173, 0.6196078431);
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 100;
  top: 0px;
}

.close {
  font-size: 25px;
  position: absolute;
  right: 8px;
  z-index: 102;
  top: calc(var(--ion-safe-area-top) + 8px);
  color: var(--ion-color-success-contrast);
}

.inner-title {
  padding: 20px;
  font-size: 18px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.inner-desc {
  padding: 20px;
  padding-top: 0px;
  font-size: 14px;
  text-align: justify;
}`, "",{"version":3,"sources":["webpack://./src/app/components/menu/attach-folio/attach-folio.component.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,0CAAA;EACA,8BAAA;EACA,iCAAA;EACA,4BAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,oBAAA;EACA,qCAAA;AACF;;AAEA;EACE;;;;;;;;;;uBAAA;EAWA,mBAAA;EACA,aAAA;AACF;;AAEA;EACE,uBAAA;EACA,UAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,0CAAA;EACA,wCAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AACF;;AAGA;EACE,mDAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;AAAF;;AAGA;EACE,eAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,yCAAA;EACA,wCAAA;AAAF;;AAGA;EACE,aAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AAAF;;AAGA;EACE,aAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAAF","sourcesContent":[".attach-folio {\n  margin: 0;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: auto;\n  background-color: var(--orwi-dialog-color);\n  box-shadow: var(--orwi-shadow);\n  border-radius: var(--orwi-radius);\n  color: var(--ion-text-color);\n  z-index: 101;\n  height: 100%;\n  width: 100%;\n  opacity: 0;\n  font-family: 'Inter';\n  padding-top: var(--ion-safe-area-top);\n}\n\n.attach-folio-inner {\n  /* height: 100%;\n  z-index: 101;\n  background-color: #807b7bf1;\n  left: 0px;\n  width: 100%;\n \n  backdrop-filter: blur(10px);\n  border-radius: 30px 30px 0px 0px;\n  padding-left: 20px;\n  padding-right: 20px;\n  position: absolute; */\n  margin-bottom: 20px;\n  padding: 20px;\n}\n\n.divider {\n  background-color: white;\n  width: 50%;\n  border-radius: 20px;\n  font-size: 7px;\n  margin: auto;\n  margin-bottom: 5px;\n  height: 10px;\n  margin-top: 10px;\n}\n\n.title {\n  width: 100%;\n  background-color: var(--ion-color-success);\n  color: var(--ion-color-success-contrast);\n  padding: 9px;\n  font-weight: bold;\n  min-height: 35px;\n}\n\n\n.orwi-actio-backdrop {\n  background-color: #abacad9e;\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  z-index: 100;\n  top: 0px;\n}\n\n.close {\n  font-size: 25px;\n  position: absolute;\n  right: 8px;\n  z-index: 102;\n  top: Calc(var(--ion-safe-area-top) + 8px);\n  color: var(--ion-color-success-contrast);\n}\n\n.inner-title {\n  padding: 20px;\n  font-size: 18px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n.inner-desc {\n  padding: 20px;\n  padding-top: 0px;\n  font-size: 14px;\n  text-align: justify;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
